export default __webpack_public_path__ + "static/media/Map.48096f5e.png";